import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { ImmutableInterface } from '../../types';

import { MessagesActionType, MessagesDataObjectProps, MessagesStoreElement } from './MessagesReducer.types';

// @ts-ignore
export const initialState: MessagesStoreElement = Immutable.fromJS({
  announcementTotal: 0,
  notificationTotal: 0,
  currentFilter: 'all',
  currentType: 'notifications',
  announcement: Immutable.List(),
  notification: Immutable.List(),
  lastMessages: Immutable.List(),
  isFetchingLastMessages: false,
  announcementFetching: false,
  notificationFetching: false,
  isFetchingMarkRead: Immutable.List(),
  shouldScroll: false,
});

function getFetchingPropertyName(type: string) {
  return `isFetching${capitalizeFirstLetter(type)}`;
}

function capitalizeFirstLetter(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

const MessagesReducer = handleActions(
  {
    REQUEST_MESSAGES: (state: MessagesStoreElement, action: MessagesActionType) =>
      state.merge(
        Immutable.fromJS({
          ...(action && action.payload.type && { [getFetchingPropertyName(action.payload.type)]: true }),
        })
      ),

    SET_TYPE: (state: MessagesStoreElement, action: MessagesActionType) =>
      state.merge(
        Immutable.fromJS({
          currentType: action.payload.currentType,
        })
      ),
    SET_FILTER: (state: MessagesStoreElement, action: MessagesActionType) =>
      state.merge(
        Immutable.fromJS({
          currentFilter: action.payload.currentFilter,
        })
      ),
    RESPONSE_MESSAGES: (state: MessagesStoreElement, action: MessagesActionType) => {
      if (action.payload.type) {
        return state.merge(
          Immutable.fromJS({
            [action.payload.type]: Immutable.fromJS(action.payload.data.results),
            [`${action.payload.type}Total`]: action.payload.data.count,
            [`${action.payload.type}Fetching`]: false,
            [getFetchingPropertyName(action.payload.type)]: false,
          })
        );
      } else {
        return state;
      }
    },

    RESPONSE_MESSAGES_FAILURE: (state: MessagesStoreElement, action: MessagesActionType) => {
      const type = action.payload.type;
      if (!type) {
        return state;
      }

      return state.merge(
        Immutable.fromJS({
          [getFetchingPropertyName(type)]: false,
        })
      );
    },

    REQUEST_LAST_MESSAGES: (state: MessagesStoreElement) =>
      state.merge(
        Immutable.fromJS({
          isFetchingLastMessages: true,
        })
      ),
    RESPONSE_LAST_MESSAGES: (state: MessagesStoreElement, action: MessagesActionType) =>
      state.merge(
        Immutable.fromJS({
          lastMessages: Immutable.fromJS(action.payload.data.results),
          isFetchingLastMessages: false,
        })
      ),

    RESPONSE_LAST_MESSAGES_FAILURE: (state: MessagesStoreElement) =>
      state.merge(
        Immutable.fromJS({
          isFetchingLastMessages: false,
        })
      ),

    RESPONSE_SUMMARY: (state: MessagesStoreElement, action: MessagesActionType) =>
      state.merge(
        Immutable.fromJS({
          summary: action.payload.data,
        })
      ),

    REQUEST_MESSAGE_MARK_READ: (state: MessagesStoreElement, action: MessagesActionType) =>
      state.merge(
        Immutable.fromJS({
          isFetchingMarkRead: state.get('isFetchingMarkRead').push(action.payload),
        })
      ),

    RESPONSE_MESSAGE_MARK_READ: (state: MessagesStoreElement, action: MessagesActionType) => {
      if (action.payload.type) {
        return state.merge(
          Immutable.fromJS({
            isFetchingMarkRead: state.get('isFetchingMarkRead').filter((id: string) => id !== action.payload.id),
            [action.payload.type]: state.get(action.payload.type).map((results: ImmutableInterface<MessagesDataObjectProps>) => {
              if (action.payload.id === results.get('id')) {
                return Immutable.fromJS(action.payload.data);
              } else {
                return results;
              }
            }),
          })
        );
      } else {
        return state.merge(
          Immutable.fromJS({
            isFetchingMarkRead: state.get('isFetchingMarkRead').filter((id: string) => id !== action.payload.id),
          })
        );
      }
    },

    MAKE_IT_SCROLL: (state: MessagesStoreElement, action: MessagesActionType) =>
      state.set('shouldScroll', true).set('currentId', action.payload),

    STOP_SCROLL: (state: MessagesStoreElement) => state.set('shouldScroll', false),

    AUTHENTICATION_LOGOUT: () => initialState,

    RESPONSE_MESSAGE_MARK_READ_FAILURE: (state: MessagesStoreElement, action: MessagesActionType) => {
      const payloadID: any = action.payload;

      return state.merge(
        Immutable.fromJS({
          isFetchingMarkRead: state.get('isFetchingMarkRead').filter((id: string) => id !== payloadID),
        })
      );
    },
  },
  initialState
);

export default MessagesReducer;
